import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'mce-discard-changes',
  imports: [MatButtonModule, MatDialogModule],
  template: `
    <h2 mat-dialog-title>Discard unsaved changes?</h2>
    <mat-dialog-content>
      Your changes haven't been saved. Leaving this page will discard them.
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button matButton type="button" [mat-dialog-close]="false">Keep editing</button>
      <button matButton="elevated" type="button" [mat-dialog-close]="true">Discard changes</button>
    </mat-dialog-actions>
  `,
})
export class DiscardChangesComponent {}
